import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-category',
  templateUrl: './new-category.component.html',
  styleUrls: ['./new-category.component.scss']
})
export class NewCategoryComponent implements OnInit,OnChanges {
  @Input() category:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  allskills = [];
  alloptions =[];
  allchoices =[];
  skills=[];
  submitting=false;
  formskillsseelcted=[];
  name="";
  type="general";
  formoptionsselected=[];
  user:any
  data = [{ skill: ''}]
  Form: FormGroup = this.fb.group({
    name: [this.name, Validators.compose([Validators.required])],
    type: [this.type, Validators.compose([Validators.required])],
    formskills: [],
    formoptions: this.fb.array([])
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.formskillsseelcted=[];
    this.formoptionsselected=[];
    this.name="";
    this.type="general";
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
    if(this.category){
      this.formskillsseelcted = this.category.skills;
      this.formoptionsselected=this.category.options;
      this.name=this.category.name;
      this.type=this.category.type;
      //this.getLevelRules(this.level.id)
    }
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
      this.getCategoryFormData()
    },500)
    $(document).ready(() => {   
        setTimeout( ()=> { 
           $('.selectpicker').selectpicker('refresh');
        }, 500); 
    });  
  } 

  typeChange(){
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
   }, 500); 
  }

  isReadOnly(){
    return this.category?'readonly':false
  }

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }
  
  get formoptions() : FormArray {
    return (this.Form.controls["formoptions"] as FormArray);
  }

  public get formoptionsControls() {
      return (this.Form.controls["formoptions"] as FormArray).controls as FormGroup[];
  }

  addOption() {
    (this.Form.controls["formoptions"] as FormArray).push(this.fb.group({
      option: [null, Validators.required],
      choice: [null, Validators.required]
    }))
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 200); 
  } 
  deleteformoptions(formruleIndex: number) {
    this.formoptions.removeAt(formruleIndex);
  }

  getUserData(){
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
    },error=>{
      this.toastrService.error("unable to handle response");
    })
  }
  
  getCategoryFormData(){
    this.adminApi.setLoader(true)
    this.adminApi.getCategoryFormData().subscribe((data: any) => {
      this.allskills = data.skills
      this.alloptions = data.options
      this.allchoices = data.choices
      setTimeout( ()=> { 
        $('.selectpicker').selectpicker('refresh');
      }, 600); 
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  initForm(){
    this.Form = this.fb.group({
      name: [this.name, Validators.compose([Validators.required])],
      type: [this.type, Validators.compose([Validators.required])],
      formskills: [this.formskillsseelcted],
      formoptions: this.fb.array([])
    });

    for(let item in this.formoptionsselected) {
      (this.Form.controls["formoptions"] as FormArray).push(this.fb.group({
        option: [this.formoptionsselected[item]['option'], Validators.required],
        choice: [this.formoptionsselected[item]['choice'], Validators.required]
      }))
    }
    setTimeout( ()=> { 
      $('.selectpicker').selectpicker('refresh');
    }, 100); 
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.category){
        form.value.id=this.category.id
      }
      this.adminApi.addCategory(form.value).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          if(!this.category){
            form.reset();
            this.type='general'
            setTimeout( ()=> { 
              $('.selectpicker').selectpicker('refresh');
            }, 100);
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      form.markAllAsTouched();
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
